<div class="card h-100" *ngIf="managers != null">
  <div class="card-header d-block">
    <div class="d-flex justify-content-between">
      <h6 class="card-title mb-0">Managers</h6>
      <span class="text-muted small">
        You have <strong class="text-muted small">{{ getManagersLength()}}</strong> Managers
      </span>
    </div>
    <app-paginator class="col-auto ms-auto"
                   [data]="managers"
                   [pageable]="pageable"
                   (newPage)="loadManagers($event)"
    ></app-paginator>
  </div>
  <div class="card-body">
    <p class="my-4" *ngIf="isEmpty()">
      Managers list is empty.
    </p>
    <div class="table-responsive" *ngIf="!isEmpty()">
      <table class="table table-sm table-borderless">
        <thead>
          <tr class="table-row table-row-head">
            <th>Name</th>
            <th>Email</th>
            <th></th>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr *ngFor="let manager of managers.content" class="table-row">
            <td>
              {{getName(manager)}}
            </td>
            <td class="text-muted">
              {{getMail(manager)}}
            </td>
            <td>
              <button (click)="delete(manager)" class="btn text-primary btn-link text-decoration-none float-end">delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer text-end">
      <a class="btn btn-primary btn-sm rounded-pill px-3 px-md-4 py-2" (click)="redirectTo('manager/new')">Add manager</a>
    </div>
  </div>
</div>
